import { createContext, useContext, useEffect, useState } from 'react'
import { useElectionsSocket } from '@nv/hooks'

const ElectionsDataContext = createContext()

export const ElectionsProvider = ({ children }) => {
  const { updates, electionData } = useElectionsSocket(process.env.NX_PUBLIC_FINISHER_SOCKET_URL)
  const [socketData, setSocketData] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (electionData) {
      setSocketData(electionData)
      setLoading(false)
    }
  }, [electionData])

  useEffect(() => {
    if (updates.length === 0) return

    const updatedState = { ...socketData }

    updates.forEach((update) => {
      const collection = update.ns?.coll
      const updateId = update.documentKey?._id

      if (!collection || !updateId) return

      const currentItems = updatedState[collection] || []

      if (update.operationType === 'update') {
        const updatedFields = update.updateDescription?.updatedFields
        updatedState[collection] = currentItems.map((item) => (item._id === updateId ? { ...item, ...updatedFields } : item))
      }

      if (update.operationType === 'insert') {
        const newDoc = update.fullDocument
        const exists = currentItems.some((item) => item._id === newDoc._id)
        if (!exists) {
          updatedState[collection] = [...currentItems, newDoc]
        }
      }

      if (update.operationType === 'delete') {
        updatedState[collection] = currentItems.filter((item) => item._id !== updateId)
      }
    })

    setSocketData(updatedState)
    setLoading(false)
  }, [updates])

  return <ElectionsDataContext.Provider value={{ socketData, loading }}>{children}</ElectionsDataContext.Provider>
}

export const useElectionsData = () => useContext(ElectionsDataContext)
